export default __webpack_public_path__ + "static/media/12H.6f14afcf.webp";